export default {
  meta: {
    title: '明细报表',
    parentPath: ['/storemanage', '/analyze/report'],
    url: '/storemanage/report', // 埋点用，记录所属模块
    // eventId: '7a6e395e-4a4d-407d-9128-32f4965e0e1b'
  },
};
